import { useEffect, useState } from 'react';

/**
 * Custom hook to monitor if a MapView is updating.
 *
 * @param view - The MapView to watch for update changes.
 * @returns A boolean indicating whether the view is currently updating.
 */
export const useMapViewUpdating = (view: __esri.MapView | undefined) => {
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    if (view) {
      const handle = view.watch('updating', (isUpdating) => setUpdating(isUpdating));
      return () => handle.remove();
    }
  }, [view]);

  return updating;
};
